import axios from "axios"
import store from "@/store"
import router from "@/router"

const URL = process.env.VUE_APP_API

const apiClient = axios.create({
  baseURL: URL,
  timeout: 30000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json"
  }
})

const refreshClient = axios.create({
  baseURL: URL,
  timeout: 30000,
  withCredentials: true
})

apiClient.interceptors.request.use((config) => {
  const token = store.getters.jwt
  const locale = store.getters.locale

  if (token) {
    config.headers.Authorization = token
  }
  if (locale) {
    config.headers["Accept-Language"] = locale
  }
  return config
})

let isRefreshing = false
let refreshSubscribers = []

function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb)
}

function onRefreshed(token) {
  refreshSubscribers.forEach((cb) => cb(token))
  refreshSubscribers = []
}

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    if (!error.response || !originalRequest) {
      return Promise.reject(error)
    }

    const status = error.response.status

    if (originalRequest.url.includes("/auth/refresh")) {
      store.commit("doLogout")
      router.push("/login")
      return Promise.reject(error)
    }

    if (status !== 401 && status !== 403) {
      return Promise.reject(error)
    }

    if (originalRequest._retry) {
      store.commit("doLogout")
      router.push("/login")
      return Promise.reject(error)
    }

    originalRequest._retry = true

    if (isRefreshing) {
      return new Promise((resolve) => {
        subscribeTokenRefresh((token) => {
          originalRequest.headers.Authorization = token
          resolve(apiClient(originalRequest))
        })
      })
    }

    isRefreshing = true

    try {
      const refreshToken = store.getters.refreshToken
      const payload = refreshToken ? { refreshToken } : {}
      const refreshRes = await refreshClient.post("/api/v1/auth/refresh", payload)
      const newAccessToken = refreshRes.data.accessToken
      if (!newAccessToken) {
        throw new Error("Refresh failed: no access token")
      }
      const newToken = `Bearer ${newAccessToken}`
      store.commit("saveJwt", newToken)

      if (refreshRes.data.userInfo) {
        store.commit("updateUserInfo", refreshRes.data.userInfo)
      }
      if (refreshRes.data.refreshToken) {
        store.commit("saveRefreshToken", refreshRes.data.refreshToken)
      }
      onRefreshed(newToken)
      isRefreshing = false
      originalRequest.headers.Authorization = newToken
      return apiClient(originalRequest)
    } catch (err) {
      isRefreshing = false
      store.commit("doLogout")
      router.push("/login")
      return Promise.reject(err)
    }
  }
)
export default apiClient
